import { useSelector } from 'react-redux'

import InitialLoadWrapper from '@/components/util/InitialLoadWrapper'
import {
  fetchProducts,
  getCustomerId,
  getError,
  getIsDataLoaded,
  getIsPending,
} from '@/ducks/shopProductsReducer'

const withShopProductsLoaded =
  // @ts-ignore


    (Component, forceLoadOnMount = false) =>
    // @ts-ignore
    props => {
      const curstomerId = useSelector(getCustomerId)

      return (
        <InitialLoadWrapper
          loadAction={fetchProducts}
          loadingSelector={getIsPending}
          loadedSelector={getIsDataLoaded}
          errorSelector={getError}
          forceLoadOnMount={forceLoadOnMount}
          args={curstomerId}
        >
          <Component {...props} />
        </InitialLoadWrapper>
      )
    }

export default withShopProductsLoaded
